import qs from 'qs'
import { useMemo } from 'react'
import { useLocation } from 'react-router'

export const useQuery = () => {
  const { search } = useLocation()

  return useMemo(() => qs.parse(search.replace('?', '')), [search])
}
